<template>
    <div name="register" class="wrapper">
        <loading v-if="isLoading" />
        <div class="page">
            <!-- <common-modal 
                :title="'시스템 점검중'"
                :message="'안녕하세요, 솔닥입니다.<br><br>더 안정적인 서비스 제공을 위해 아래 시간 동안 시스템 점검이 진행될 예정입니다.<br><br>점검 일시: 2026.10.19 월요일 오후 21:00 ~ 23:00<br><br>점검 시간 동안은 서비스 접속 및 이용이 어려울 수 있으며, 점검 완료 후 정상적으로 이용하실 수 있습니다.'"
                :buttonCount="0"
            />     -->
            <address-modal 
                v-if="isAddressInputModal"
                @onClose="closeAddressInputModal"
                @apply="addressApply"
                :isUpdate="isUpdateAddress"
                :preAddress="address"
                :preDetailAddress="detailAddress" 
                :preAddressNickname= "addressNickname"
                :preZipCode="zipCode"
                :preAddressDescription="addressDescription"
            />
            <common-modal 
                :title="'선택하신 2형 당뇨는 청구 위임 대상이 아니에요'"
                :message="'2형 당뇨의 청구 위임 서비스는 현재 준비 중이에요.<br>지금은 청구 위임 없이 카드 등록 단계로 이어집니다.<br><br><br><br>'"
                :button1Text="'확인'"
                :button2Text="'확인'"
                @onClose="closeCommonModal"
                @onClickButton1="t2NextStep"
                @onClickButton2="closeCommonModal"
                :buttonCount="1"
                v-if="isCommonModal"
            />
            <confirm-modal 
                @onClose="onInfoClose"
                @onYes="onInfoYes"
                v-if="isConfirm"
            />
            <error-modal 
                v-if="error"
                :error="error"
                @onClose="closeErrorModal"
            />
            <global-duplicate-modal 
                v-if="isGlobalDuplicateModal" 
                @onClose="closeGlobalDuplicateModal"
                @onCloseAndCs="closeGlobalDuplicateModalAndCs"
                :name="`${draftProfile.name} (${draftProfile.registration_number.substring(0, 6)}-${draftProfile.registration_number.substring(6, 7)})`"
            />
            <duplicate-modal v-if="isDuplicateModal" 
                @onClose="closeDuplicateModal"
                :name="draftProfile.name"
            />
            <div class="button-header">
                <img @click="back" style="width: 22px; cursor: pointer;" src="../assets/arrow_back.png" />
            </div>
            <steps
                :isStepper="true" 
                :step=1 
                :isRare="isWithoutDelegation"
            />
            <div class="input-area">
                <text-label 
                    :text="'질환 유형'"
                    :isDefault="true"
                />
                <radio-button-list 
                    :labelList="['1형 당뇨', '임신성 당뇨 (인슐린 투여)', '임신성 당뇨 (인슐린 미투여)', '2형 당뇨', '자가도뇨 카테터 대상자', '희귀난치성질환 대상자']"
                    :selectedIndex="selectedDiabetesTypeIndex"
                    :isError="isSelectDiabetesTypeError"
                    @select="selectDiabetesType"
                    ref="type"
                />
                <div class="error-info-text" v-if="isSelectDiabetesTypeError" style="margin-top: -5px;margin-bottom: 20px;">질환 유형을 선택해 주세요</div>
                <text-label 
                    :text="'환자명'"
                    :isDefault="true"
                />
                <input v-model="name" 
                    v-focus-background
                    style="background-color: var(--Gray-20, #F3F5F8)"
                    ref="name"
                    class="input-big"
                    placeholder="이름을 적어주세요"
                />
                <div class="error-info-text">{{ nameError }}</div>
                <text-label 
                    :text="'주민(외국인)등록번호'"
                    :isDefault="true"
                />
                <div style="margin-bottom: 8px; display: flex; align-items: center; justify-content: center; width: 100%; position: relative;" >
                    <input v-model="registrationNumber1" inputmode="numeric" 
                        v-focus-background
                        class="input-medium"
                        placeholder="앞 6자리"
                        maxlength="6"
                        ref="registrationNumber1"
                    /> 
                    <span style="margin-right: 7px;">-</span> 
                    <input :type="isViewPassword ? '' : 'password'" v-model="registrationNumber2" inputmode="numeric" name="custom-password" autocomplete="off"
                        v-focus-background
                        class="input-medium"
                        placeholder="뒤 7자리"
                        maxlength="7"
                        ref="registrationNumber2"
                    />
                    <img 
                        v-if="!isViewPassword"
                        @click="() => isViewPassword = !isViewPassword"
                        src="../assets/unview_password.png"
                        class="view-password"
                    />
                    <img 
                        v-else
                        @click="() => isViewPassword = !isViewPassword"
                        src="../assets/view_password.png"
                        class="view-password"
                    />
                </div>    
                <div class="row">
                    <span class="info-text">병원에서 <span class="info-color-text">진료와 처방전 발행</span>에 필요해요</span>
                </div>   
                <div class="error-info-text">{{ registrationNumberError }}</div>
                <text-label 
                    :text="'휴대폰번호'"
                    :isDefault="true"
                />
                <input 
                    v-model="draftProfile.phone_number"
                    inputmode="numeric"
                    v-focus-background
                    class="input-big"
                    placeholder="진료 받으실 분의 휴대폰번호를 적어주세요"
                    ref="phone"
                />
                <div class="row" style="margin-top: 8px;">
                    <span class="info-text">진료 시간이 되면 <span class="info-color-text">의사가 전화로 연락</span>드려요</span>
                </div> 
                <div class="error-info-text">{{ phoneError }}</div>
                <text-label 
                    :text="'배송지 정보'"
                    :isDefault="false"
                />
                <span class="info-text" v-if="address === null && zipCode === null && detailAddress === null && addressNickname === null">배송지를 미리 등록해 두시면 결제부터 배송까지 더욱 빠르게 이용하실 수 있어요</span>
                <div class="plus-button" v-if="address === null && zipCode === null && detailAddress === null && addressNickname === null" style="margin-top: 16px;" @click="inputAddress">
                    <img style="width: 22px;" src="../assets/plus_btn.png" />
                    <span style="margin-left: 16px;">배송지 등록</span>
                </div>
                <address-card 
                    v-else
                    :address="address"
                    :detailAddress="detailAddress"
                    :addressNickname="addressNickname"
                    :zipCode="zipCode"
                    :addressDescription="addressDescription"
                    @updateAddress="updateAddress"
                />
            </div>
            <!-- agree area -->
             <div class="agree-area">
                <span class="agree-title">약관에 동의해 주세요<span class="red">*</span></span>
                <div class="all-agree" ref="agree" >
                    <check-box 
                        :checked="allAgree"
                        @onClick="allAgreeFunction"
                    />
                    <span @click="allAgreeFunction" class="all-agree-text">모두 동의합니다.</span>
                </div>
                <div class="agree-detail-box" style="margin-top: 31px">
                    <div class="row">
                        <check-box 
                            :checked="agreement_personal_info"
                            @onClick="() => {agreement_personal_info = !agreement_personal_info}"
                        />
                        <span @click="() => {agreement_personal_info = !agreement_personal_info}" class="agree-text"><span style="color: var(--point-color3, #FF000F)">(필수)</span> 개인정보 수집 및 이용 동의</span>
                    </div>
                    <img style="width: 20px;cursor: pointer;" @click="openPolicy(2)" src="../assets/detail.png" />
                </div>
                <div class="agree-detail-box" style="margin-top: 18px">
                    <div class="row">
                        <check-box 
                            :checked="agreement_sensitive_info"
                            @onClick="() => {agreement_sensitive_info = !agreement_sensitive_info}"
                        />
                        <span @click="() => {agreement_sensitive_info = !agreement_sensitive_info}" class="agree-text"><span style="color: var(--point-color3, #FF000F)">(필수)</span> 민감정보 수집 및 이용 동의</span>
                    </div>
                    <img style="width: 20px;cursor: pointer;" @click="openPolicy(3)" src="../assets/detail.png" />
                </div>
                <div v-if="agreeError" class="error-info-text">이용약관에 동의해 주세요</div>
                <span class="footer-text">*본 서비스는 특정 의료기관 이용을 강제하지 않습니다. 대면·비대면 어디서든 발급받은 처방전으로 의료물품을 구매할 수 있으며, 이용 병원에 관계없이 서비스와 혜택에 차이는 없습니다.</span>
             </div>
             <!-- next -->
            <div style="width: 100%; padding: 0 16px; box-sizing: border-box; margin-top: 40px;margin-bottom: 40px;">
                <bottom-button 
                    :text="'다음 단계'"
                    :color="'var(--Gray-100, #1E1E1E)'"
                    @onClick="nextStep"
                />
            </div>
        </div>
    </div>
</template>

<script>
import focusBackground from '@/components/directives/focusBackground';
import CheckBox from '@/components/atoms/CheckBox';
import LoginHeader from '@/components/molecules/LoginHeader'
import TextLabel from '@/components/atoms/TextLabel';
import BottomButton from '@/components/atoms/BottomButton';
import {mapState} from 'vuex';
import PageFooter from '@/components/molecules/PageFooter';
import ErrorModal from '@/components/modals/ErrorModal';
import Constant from '@/constant';
import Convert from '@/utilities/convert';
import Validation from '@/utilities/validation';
import cookies from '@/utilities/cookie.js';
import Steps from '@/components/molecules/Steps';
import DuplicateModal from '@/components/modals/DuplicateModal';
import ConfirmModal from '@/components/modals/ConfirmModal';
import Loading from '@/components/molecules/Loading';
import RadioButtonList from '@/components/molecules/RadioButtonList';
import CommonModal from '@/components/modals/CommonModal';
import GlobalDuplicateModal from '@/components/modals/GlobalDuplicateModal.vue';
import AddressModal from '@/components/modals/AddressModal';
import AddressCard from '../components/molecules/AddressCard.vue';

export default {
    name: 'register',
    computed: {
        ...mapState(['profile', 'agreements', 'draftProfile']),
        allAgree: function()
        {
            return this.agreement_personal_info && this.agreement_sensitive_info;
        },
        // 위임장을 쓰지 않는 유형이라 단계 표시에서 '청구 위임'을 뺀다
        isWithoutDelegation: function()
        {
            return this.selectedDiabetesTypeIndex === 3       // 2형 당뇨
                || this.selectedDiabetesTypeIndex === 4       // 자가도뇨 카테터
                || this.selectedDiabetesTypeIndex === 5;      // 희귀난치성질환
        },
        // 위임장 화면 자체를 건너뛰고 카드 등록으로 바로 가는 유형
        // 2형 당뇨는 위임장 화면에서 안내 모달을 띄운 뒤 건너뛰므로 여기에 넣지 않는다
        isSkipContract: function()
        {
            return this.selectedDiabetesTypeIndex === 4       // 자가도뇨 카테터
                || this.selectedDiabetesTypeIndex === 5;      // 희귀난치성질환
        }
    },
    data: function()
    {
        return {
            registrationNumber1: '',
            registrationNumber2: '',
            agreement_personal_info: false,
            agreement_terms_condition_description: false,
            agreement_marketing: false,
            agreement_sensitive_info: false,
            agreeError: false,
            error: null,
            name: '',
            token: null,
            isDuplicateModal: false,
            isUpdate: false,
            isConfirm: false,
            previousUrl: null,
            isLoading: false,
            isViewPassword: false,
            nameError: '',
            registrationNumberError: '',
            phoneError: '',
            selectedDiabetesTypeIndex: -1,
            isSelectDiabetesTypeError: false,
            isCommonModal: false,
            isGlobalDuplicateModal: false,
            isAddressInputModal: false,
            address: null,
            detailAddress: null, 
            addressNickname: null,
            addressDescription: null,
            zipCode: null,
            isUpdateAddress: false
        }
    },  
    components: {
        LoginHeader,
        TextLabel,
        CheckBox,
        BottomButton,
        ErrorModal,
        PageFooter,
        Steps,
        DuplicateModal,
        ConfirmModal,
        Loading,
        RadioButtonList,
        CommonModal,
        GlobalDuplicateModal,
        AddressModal,
        AddressCard
    },
    directives: {
        focusBackground
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.previousUrl = from.fullPath || "None";
        });
    },
    mounted: function()
    {
        ChannelIO('shutdown')
        this.topFunction();
        // 진입점에 따라 초기화 구분 
        // 이전 페이지가 /home, /contract 라면 초기화 하지 않음 
     
        if(this.previousUrl !== '/contract')
        {
            // this.$store.commit(Constant.INITALIZE_DIABETES_REQUEST);  // v2 수정 
            this.$store.commit(Constant.INITIALIZE_DRAFT_PROFILE);
        }
        else {

            // v2 수정 필요함  
            this.name = this.draftProfile.name;
            this.registrationNumber1 = this.draftProfile.registration_number.substring(0, 6);
            this.registrationNumber2 = this.draftProfile.registration_number.substring(6, 14);

            this.address = this.draftProfile.address;
            this.detailAddress = this.draftProfile.detail_address;
            this.zipCode = this.draftProfile.zip_code;
            this.addressNickname = this.draftProfile.address_nickname;
            this.addressDescription = this.draftProfile.address_description;
            this.selectedDiabetesTypeIndex =
            this.draftProfile.diabetes_type === 'TYPE1' ? 0 : 
            this.draftProfile.diabetes_type === 'GESTATIONAL' ? 1 : 
            this.draftProfile.diabetes_type === 'GESTATIONAL_WITHOUT_INSULIN' ? 2 : 
            this.draftProfile.diabetes_type === 'TYPE2' ? 3 :
            this.draftProfile.diabetes_type === 'SELF_CATHETER' ? 4 :
            this.draftProfile.diabetes_type === 'RARE_INTRACTABLE' ? 5 : -1
        }

        this.token = cookies.getLocalStorage("access_token");
        if(this.token === null || this.token === undefined || this.token === '')
        {
            this.token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'register'}})
        }
        else
        {
            
            // 유효성 체크    
            this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                .then(() => {

                }) 
                .catch(() => {
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'register'}})
                })
        }
    },
    methods: {
        updateAddress: function()
        {
            this.isUpdateAddress = true;
            this.isAddressInputModal = true;
        },
        inputAddress: function()
        {
            this.isAddressInputModal = true;
        },
        closeAddressInputModal: function()
        {
            this.isUpdateAddress = false;
            this.isAddressInputModal = false;
        },
        addressApply: function(address, detailAddress, addressNickname, zipCode, addressDescription)
        {
            this.isUpdateAddress = false;
            this.isAddressInputModal = false;
            this.address = address;
            this.detailAddress = detailAddress;
            this.addressNickname = addressNickname;
            this.zipCode = zipCode;
            this.addressDescription = addressDescription;
        },
        closeCommonModal: function()
        {
            this.isCommonModal = false;
        },
        questionCs: function()
        {
            window.open("https://solcon.channel.io/home", "_blank")
        },
        selectDiabetesType: function(type){

            this.isSelectDiabetesTypeError = false
            this.selectedDiabetesTypeIndex = type;
        },
        t2NextStep: function()
        {

        },
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        onInfoYes: function()
        {
            this.isConfirm = false;
            this.isUpdate = false;
            if(this.previousUrl === '/apply')
            {
                this.$router.push('/apply')
            }
            else
            {
                this.$router.push('/home')
            }
        },
        onInfoClose: function()
        {
            this.isConfirm = false;
        },
        closeDuplicateModal: function()
        {
            this.isDuplicateModal = false;
            this.$router.push({path: '/apply'})
        },
        closeGlobalDuplicateModalAndCs: function()
        {
            this.isGlobalDuplicateModal = false;
            ChannelIO('boot', {
                "pluginKey": "90e69520-1088-43c6-a1cc-3019437a9be8"
            });
            ChannelIO('showMessenger')
        },
        closeGlobalDuplicateModal: function()
        {
            this.isGlobalDuplicateModal = false;
            this.$router.push({path: '/home'})
        },
        closeErrorModal: function()
        {
            this.error = null;
        },
        allAgreeFunction: function()
        {
            const next = !this.allAgree;
            this.agreement_personal_info = next;
            this.agreement_sensitive_info = next;
        },
        openPolicy: function(index)
        {   
            if(index === 1)
            {
                window.open("https://policy.soldoc.co.kr/terms", '_blank')
            }
            else if(index === 2)
            {
                window.open("https://policy.soldoc.co.kr/privacy-consent/profile", '_blank')
            }
            else if(index === 3)
            {
                if(this.selectedDiabetesTypeIndex !== 5)
                {
                    window.open("https://policy.soldoc.co.kr/barocare-sensitive", '_blank')
                }
                else
                {
                    window.open("https://policy.soldoc.co.kr/barocare-rare-sensitive", '_blank')    
                }           
            }
            else if(index === 4)
            {
                window.open("https://policy.soldoc.co.kr/marketing", '_blank')
            }
        },
        errorFocus: function(field)
        {
            if(field === 'type')
            {
                const offsetTop = this.$refs[field].offsetTop;
                    window.scrollTo({
                        top: offsetTop - 50, // 50px 위로 조정
                        behavior: 'smooth'
                });
                return;
            }

            this.$refs[field].style.border = '1.5px solid var(--Semantic-01_Red, #FF000F)';

            const offsetTop = this.$refs[field].offsetTop;
                window.scrollTo({
                    top: offsetTop - 50, // 50px 위로 조정
                    behavior: 'smooth'
            });
        },
        validateResidentNumber: function (residentNumber) {
            // 정규식: 6자리 숫자(생년월일) + 1자리 숫자(성별 코드)
            residentNumber  = residentNumber.substring(0, 7);
            const regex = /^(\d{6})(\d)$/;
            const match = residentNumber.match(regex);

            if (!match) {
                console.log("[주민등록번호 에러] 형식이 올바르지 않습니다.");
                return 0;
                // return { valid: false, message: "형식이 올바르지 않습니다." };
            }

            const birthPart = match[1]; // YYMMDD
            const genderCode = parseInt(match[2], 10); // 1자리 성별 코드

            // 생년월일 유효성 검사
            const year = parseInt(birthPart.substring(0, 2), 10);
            const month = parseInt(birthPart.substring(2, 4), 10);
            const day = parseInt(birthPart.substring(4, 6), 10);

            // 성별 코드 검증 (1~8)
            if (![1, 2, 3, 4, 5, 6, 7, 8].includes(genderCode)) {
                console.log("[주민등록번호 에러] 잘못된 성별 코드입니다.");
                return 1;
                // return { valid: false, message: "잘못된 성별 코드입니다." };
            }

            // 출생 연도 계산 (성별 코드에 따라 1900년대, 2000년대 결정)
            let fullYear;
            if (genderCode === 1 || genderCode === 2 || genderCode === 5 || genderCode === 6) {
                fullYear = 1900 + year;
            } else if (genderCode === 3 || genderCode === 4 || genderCode === 7 || genderCode === 8) {
                fullYear = 2000 + year;
            } else {
                console.log("[주민등록번호 에러] 올바르지 않은 성별 코드입니다.");
                return 1;
                // return { valid: false, message: "올바르지 않은 성별 코드입니다." };
            }
            const cur = new Date();
            if(cur.getFullYear() < fullYear)
            {
                console.log("[주민등록번호 에러] 올바르지 않은 성별 코드입니다.");
                return 1;
            }
         
            // 유효한 날짜인지 확인
            const birthDate = new Date(fullYear, month - 1, day);
            if (
                birthDate.getFullYear() !== fullYear ||
                birthDate.getMonth() + 1 !== month ||
                birthDate.getDate() !== day
            ) {
                console.log("[주민등록번호 에러] 유효하지 않은 생년월일입니다.");
                return 2;
                // return { valid: false, message: "유효하지 않은 생년월일입니다." };
            }

            return 3;
            // return { valid: true, message: "유효한 주민등록번호입니다." };
        },
        nextStep: function()
        {

            if(this.selectedDiabetesTypeIndex === -1)
            {
                this.errorFocus('type');
                this.isSelectDiabetesTypeError = true;
                return;
            }

            // 이름, 주민등록번호 validation
            if(this.name == '')
            {
                this.errorFocus('name');
                this.nameError = '이름을 입력해 주세요. (한글 또는 영문만 가능)';
                return;
            }

            if(Convert.containsNumber(this.name))
            {
                this.errorFocus('name');
                this.nameError = '한글 또는 영문으로 입력해 주세요.';
                return;
            }

            if(!Validation.isValidName(this.name))
            {
                this.errorFocus('name');
                this.nameError = "공백 없이 완성된 글자로 입력해 주세요. (예 'ㄷㅏ', '홍 길동' 불가)";
                return;
            }

            if(this.registrationNumber1.length !== 6)
            {
                this.errorFocus('registrationNumber1')
                this.registrationNumberError = '주민등록번호는 앞 6자리, 뒷 7자리로 입력해 주세요.';
                return;
            }

            if(this.registrationNumber2.length !== 7)
            {
                this.errorFocus('registrationNumber2')
                this.registrationNumberError = '주민등록번호는 앞 6자리, 뒷 7자리로 입력해 주세요.';
                return;
            }

            
            this.draftProfile.name = this.name.trim();
            this.draftProfile.registration_number = `${this.registrationNumber1}${this.registrationNumber2}`;

            // console.log(this.validateResidentNumber(this.body.profile.registration_number))

            
            if(this.validateResidentNumber(this.draftProfile.registration_number) === 0)
            {
                this.errorFocus('registrationNumber1')
                this.errorFocus('registrationNumber2')
                this.registrationNumberError = '주민등록번호는 앞 6자리, 뒷 7자리로 입력해 주세요.';
                return;
            }

            if(this.validateResidentNumber(this.draftProfile.registration_number) === 1)
            {
                this.errorFocus('registrationNumber2')
                this.registrationNumberError = '주민등록번호의 성별 코드가 올바르지 않습니다.';
                return;
            }

            if(this.validateResidentNumber(this.draftProfile.registration_number) === 2)
            {
                this.errorFocus('registrationNumber1')
                this.registrationNumberError = '생년월일이 올바르지 않습니다.';
                return;
            }

            if(this.draftProfile.phone_number == '')
            {
                this.errorFocus('phone');
                this.phoneError = '휴대폰번호를 입력해 주세요.';
                return;
            }


            if(!Validation.isValidPhoneNumber(this.draftProfile.phone_number))
            {
                this.errorFocus('phone')
                this.phoneError = '유효한 휴대폰번호 형식이 아닙니다.';
                return;
            }
            
            if(!this.agreement_personal_info)
            {
                this.agreeError = true;
                return;
            }

            if(!this.agreement_sensitive_info)
            {
                this.agreeError = true;
                return;
            }

            if(this.address == null)
            {
                // 주소 관련 다혜님께 문의
                this.draftProfile.address = null;
                this.draftProfile.detail_address = null
                this.draftProfile.zip_code = null
                this.draftProfile.address_nickname = null
                this.draftProfile.address_description = null
            }
            else
            {
                this.draftProfile.address = this.address;
                this.draftProfile.detail_address = this.detailAddress;
                this.draftProfile.zip_code = this.zipCode;
                this.draftProfile.address_nickname = this.addressNickname;
                this.draftProfile.address_description = this.addressDescription;
            }


            this.draftProfile.diabetes_type = 
            this.selectedDiabetesTypeIndex === 0 ? 'TYPE1' : 
            this.selectedDiabetesTypeIndex === 1 ? 'GESTATIONAL' : 
            this.selectedDiabetesTypeIndex === 2 ? 'GESTATIONAL_WITHOUT_INSULIN' : 
            this.selectedDiabetesTypeIndex === 3 ? 'TYPE2' : 
            this.selectedDiabetesTypeIndex === 4 ? 'SELF_CATHETER' : 
            this.selectedDiabetesTypeIndex === 5 ? 'RARE_INTRACTABLE' : null

            this.draftProfile.agreement_personal_info = true;
            this.draftProfile.agreement_sensitive_info = true;
            // this.draftProfile.premedical_info.file_list = [];  // 파일 초기화

            this.isLoading = true;

            //v2
            this.$store.dispatch(Constant.ADD_DRAFT_PROFILE, {token: this.token})
                .then((res) => {
                    this.isLoading = false;



                    // 희귀질환 아님 
                    if(res.delegation_info != null)
                    {
                        // 이미 위임 정보가 있기때문에 5번으로 이동이 필요함 
                        this.$store.commit(Constant.FETCH_PRE_DELEGATION_INFO, {
                            pre_delegation_info: res.delegation_info,
                            is_loading: true,
                            profile_id: res.profile.id

                        })
                    }
                    else 
                    {
                        
                        
                        this.$store.commit(Constant.FETCH_PRE_DELEGATION_INFO, {
                            pre_delegation_info: {is_delegated: false, started_at: null, expired_at: null},
                            is_loading: true,
                            profile_id: res.profile.id

                        })
                        
                    }

                    // 위임장 없이 진행 (희귀난치성질환, 자가도뇨 카테터)
                    if(this.isSkipContract)
                    {
                        this.isLoading = true;
                        this.$store.dispatch(Constant.SAVE_DELEGATE_FALSE, {profile_id: res.profile.id, token: this.token})
                            .then(() => {
                                this.isLoading = false; 
                                this.$router.push({path: '/card'})
                            })
                            .catch((err) => {
                                this.error = err;
                                this.isLoading = false; 
                            })
                    }
                    else
                    {
                        this.$router.push({path: '/contract'})
                    }

                })
                .catch((err) => {
                    
                    this.isLoading = false;
                    if(err.code === "CONCIERGE0013") //  내 계정 중복 
                    {
                        this.isDuplicateModal = true;
                    }
                    else if(err.code === 'CONCIERGE0113')
                    {
                        this.isGlobalDuplicateModal = true;
                    }
                    else
                    {
                        this.error = err;
                        this.isLoading = false;
                    }
                })
        },
        back: function()
        {
            if(this.isUpdate)
            {
                this.isConfirm = true;
            }
            else
            {
                if(this.previousUrl === '/apply')
                {
                    this.$router.push('/apply')
                }
                else
                {
                    this.$router.push('/home')
                }
            }
            
        },
        validateRRN: function(rrn) {
            // 정규식: 13자리 숫자인지 확인
            if (!/^\d{13}$/.test(rrn)) {
                return false;
            }

            const rrnFront = rrn.substring(0, 6); // 앞 6자리 (생년월일)
            const seventhDigit = parseInt(rrn.charAt(6), 10); // 7번째 숫자

            // 앞 6자리 생년월일 검증
            if (!validateRRNFront(rrnFront)) {
                return false;
            }

            // 7번째 숫자가 출생 연도와 일치하는지 검증
            if (!validateSeventhDigit(rrnFront, seventhDigit)) {
                return false;
            }

            return true;
        },
        // 생년월일 검증 함수
        validateRRNFront: function(rrnFront) {
            const regex = /^(?:\d{2})(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])$/;

            if (!regex.test(rrnFront)) {
                return false;
            }

            const year = parseInt(rrnFront.substring(0, 2), 10);
            const month = parseInt(rrnFront.substring(2, 4), 10);
            const day = parseInt(rrnFront.substring(4, 6), 10);
            const fullYear = year >= 30 ? 1900 + year : 2000 + year;

            const date = new Date(fullYear, month - 1, day);
            return date.getFullYear() === fullYear && date.getMonth() + 1 === month && date.getDate() === day;
        },
        // 7번째 숫자 검증 함수 (출생 연도와 연관)
        validateSeventhDigit: function(rrnFront, seventhDigit) {
            const year = parseInt(rrnFront.substring(0, 2), 10);
            const fullYear = year >= 30 ? 1900 + year : 2000 + year;

            if (fullYear >= 1900 && fullYear <= 1999) {
                return seventhDigit === 1 || seventhDigit === 2; // 1900~1999년생 → 1, 2
            } else if (fullYear >= 2000 && fullYear <= 2099) {
                return seventhDigit === 3 || seventhDigit === 4; // 2000~2099년생 → 3, 4
            }

            return false; // 그 외의 경우는 유효하지 않음
        }
    },
    watch: {
        selectedDiabetesTypeIndex: function()
        {
            this.isSelectDiabetesTypeError = false
        },
        name: function()
        {
            this.isUpdate = true;
            this.nameError = '';
        },
        agreement_personal_info: function()
        {
            this.agreeError = false;
        },
        agreement_sensitive_info: function()
        {
            this.agreeError = false;
        },
        registrationNumber1: function(newValue) {
            this.registrationNumber1 = newValue.replace(/[^0-9]/g, '');
            this.isUpdate = true;
            this.registrationNumberError = '';
        },
        registrationNumber2(newValue) {
            this.registrationNumber2 = newValue.replace(/[^0-9]/g, '');
            this.isUpdate = true;
            this.registrationNumberError = '';
        },
        'draftProfile.phone_number'(newValue) {
            this.draftProfile.phone_number = newValue.replace(/[^0-9]/g, '');
            this.isUpdate = true;
            this.phoneError = '';
        },
    }
}
</script>

<style scoped>

    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .page {
        width: 100%;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }

    .input-area {
        width: 100%;
        padding: 20px 16px 30px 16px;
        border-bottom: 8px solid var(--Gray-sub-color1, #F3F5F8);
        box-sizing: border-box;
    }
    .agree-area {
        padding: 40px 16px 0 16px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;

    }


    .input-big {
        width: 100%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }

    .input-medium {
        width: 50%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        margin-right: 7px;
    }
    .info-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
    }
    .info-color-text {
        color: #184FA1;
    }
    .all-agree {
        height: 60px;
        flex-shrink: 0;
        width: calc(100%);
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding-left: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        margin-top: 30px;
        box-sizing: border-box;
    }
    .all-agree-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 100% */
        cursor: pointer;
        margin-left: 17px;
    }
    .agree-detail-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100%);
        box-sizing: border-box;
    }
    .agree-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin-left: 17px;
    }
    .row {
        display: flex;
    }
    .error-info-text {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 8px;
    }
    .agree-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
    .red {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px;
    }
    .button-header {
        width: 100%;
        height: 75px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20.32px 15.5px;
        box-sizing: border-box;
        background: var(--Gray-20, #F3F5F8);
    }
    .view-password {
        position: absolute;
        right: 16px;
        z-index: 2;
        cursor: pointer;
    }
    .plus-button {
        border-radius: 10px;
        border: 1px dashed var(--Gray-50, #A3AAB6);
        background: var(--Gray-20, #F3F5F8);
        width: 100%;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        height: 62px;
        cursor: pointer;
    }
    .footer-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 128.571% */
        margin-top: 32px;
    }
</style>


// WEBPACK FOOTER //
// src/page/Register.vue